import React from "react"
import styled from "styled-components"
import { ButtonStyleGreen, ButtonStyleGreenDisabled } from "./Styles"
import PropTypes from "prop-types"

const ButtonContainer = styled.button`
  ${(props) => (props.disabled ? ButtonStyleGreenDisabled : ButtonStyleGreen)}
`;

const OnClickButtonGreen = ({onClick, children, ...rest}) => {
  return (
    <ButtonContainer onClick={onClick} {...rest}>
      {children}
    </ButtonContainer>
  )
};

OnClickButtonGreen.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default OnClickButtonGreen
